import * as constants from '../constants/poi';

/**
 * Sets the poi list
 *
 * @export
 * @param {Array<object>} pois
 * @returns {object}
 */
export function setPois (pois) {
    return {
        type: constants.SET_POIS,
        pois
    }
}



// WEBPACK FOOTER //
// ./src/actions/poi.js